import {condition, request} from "../../../../../../../res/rest/restRequest";
import SingleProductSalesChart from "../SingleProductSalesChart";
import {useMemo, useState} from "react";
import useValueChangeListener from "../../../../../../services/state/general/useValueChangeListener";
import './salesLayout.css'
import SalesFilter from "./SalesFilter";
import useVendorProducts from "../../../../../../services/state/vendor/useVendorProducts";
import LoadingSwitcher from "../../../../../../component/general/loading/LoadingSwitcher";
import {useSearchParams} from "react-router-dom";
import Pagination from "../../../../../../component/navigation/Pagination";
import useAuthRequest from "../../../../../../services/state/request/useAuthRequest";

const getMonthlySales = (pids) => async (session) => {
    const resp = await request.model("sales_vendor_monthly_report_v")
        .filter(condition.eq("c_bpartner_ID", session.bPartnerID))
        .filter(condition.in("m_product_ID", ...pids))
        .get(session);

    const byPid = {};
    const max = {maxSales: 0, maxTotal: 0};
    for(const l of resp) {
        const pid = l.M_Product_ID.id;
        if(!byPid[pid]) {
            byPid[pid] = [];
        }
        byPid[pid].push(l);

        if(l.Sales > max.maxSales) max.maxSales = l.Sales;
        if(l.last_period_sales > max.maxSales) max.maxSales = l.last_period_sales;
        if(l.total > max.maxTotal) max.maxTotal = l.total;
    }

    return {...byPid, ...max};
}

const ProductChart = ({data, showTotal, scaleHeight}) => {

    const firstLine = data?.[0];
    const vendorCode = firstLine?.VendorProductNo;
    const productCode = firstLine?.Value;
    const name = firstLine?.Description;


    return (
        <div className="chart-container">
            <p className="acct-h2">{vendorCode ? vendorCode : productCode} - {name}</p>
            <div className="chart-container-again" style={{height: 400}}>
                <SingleProductSalesChart
                    data={data}
                    showTotal={showTotal}
                    scaleHeight={scaleHeight}
                />
            </div>
        </div>
    )

}

const PAGE_SIZE = 10;
const useSalesProducts = (products) => {

    const {
        loading,
        result,
        sendIt
    } = useAuthRequest()


    useValueChangeListener(() => {
        if(!products || products.length === 0) return;
        const pids = products.map(p => p.id);
        sendIt(getMonthlySales(pids));
    }, [products]);

    return {
        chartData: result,
        loading,
    }
}

const useLayoutParams = () => {

    const [{
        showTotal,
        uniformScale,
        useGrid
    }, setLayout] = useState({ showTotal: false, uniformScale: true, useGrid: true });

    const onLayoutChange = (field, val) => {
        if(field === "Grid") {
            if(!useGrid && val === "Grid") {
                setLayout({showTotal, uniformScale, useGrid: true});
            } else if(useGrid && val === "List") {
                setLayout({showTotal, uniformScale, useGrid: false});
            }
        } else if(field === "Total") {
            if(!showTotal && val === "Show Total") {
                setLayout({showTotal: true, uniformScale, useGrid});
            } else if(showTotal && val === "Hide Total") {
                setLayout({showTotal: false, uniformScale, useGrid});
            }
        } else if(field === "Scale") {
            if(!uniformScale && val === "Uniform Scale") {
                setLayout({showTotal, uniformScale: true, useGrid});
            } else if(uniformScale && val === "Individual Scale") {
                setLayout({showTotal, uniformScale: false, useGrid});
            }
        }
    }

    return {
        showTotal,
        uniformScale,
        useGrid,
        onLayoutChange
    }

}

const SalesLayout = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    const pageNoPara = searchParams.get('page');
    const pageNo = pageNoPara ? Number(pageNoPara) : 1;

    const changePage = (pageNo) => {
        setSearchParams(p => {
            p.set('page', pageNo);
            return p;
        })
    };

    const {
        loading,
        products,
        count,
        getProducts
    } = useVendorProducts();

    useValueChangeListener(() => {
        getProducts({pageNo, pageSize: PAGE_SIZE, filters: "111=Sales (high to low)"})
    }, [pageNo], [-1]);
    const pageCount = (Math.ceil(count / 10));

    const {
        showTotal,
        uniformScale,
        useGrid,
        onLayoutChange
    } = useLayoutParams();

    const {
        loading: chartDataLoading,
        chartData
    } = useSalesProducts(products);

    const scaleHeight = useMemo(() => {
        if(uniformScale && chartData) {
            return showTotal ? chartData.maxTotal : chartData.maxSales;
        }
    }, [uniformScale, showTotal, chartData]);

    return (
        <>
            <div className="acct-content dashboard-sales-container">
                <LoadingSwitcher className="bold" loading={loading || chartDataLoading} >
                    <div className={`dashboard-chart-container${useGrid ? " grid" : ""}`}>
                        {products && products.map((p, i) => (p.id && chartData && chartData[p.id] &&
                            <ProductChart
                                data={chartData[p.id]}
                                key={i}
                                showTotal={showTotal}
                                scaleHeight={scaleHeight}
                            />
                        ))}
                    </div>
                    <Pagination
                        currentPage={pageNo}
                        loading={loading}
                        lastPage={pageCount}
                        onPageRequested={changePage}
                    />
                </LoadingSwitcher>
            </div>
            <SalesFilter onLayoutChange={onLayoutChange}/>
        </>
    )
}

export default SalesLayout;
